<template>
  <div class="loginForm">
    <el-form ref="ruleForm" :model="ruleForm" :rules="rules">
      <el-form-item prop="tel" style="margin-bottom:27px;">
        <el-input @focus="clearShow = true" @blur="clearShow=false" clearable ref="telRef" v-model="ruleForm.tel" placeholder="请输入手机号码">
          <!-- <template slot="suffix">
            <i v-show="clearShow || ruleForm.tel" @mousedown.prevent="clearHandle"  class="el-icon-error" style="color:#333333;cursor:pointer;"></i>
          </template> -->
        </el-input>
      </el-form-item>
      <el-form-item prop="passWord"  style="margin-bottom:27px;">
        <el-input
          :type="IsShow ? 'password' : 'text'"
          v-model="ruleForm.passWord"
          placeholder="请输入密码"
        >
          <template slot="suffix">
            <img
              v-show="IsShow && !ruleForm.passWord"
              @click="IsShow = !IsShow"
              src="../images/hide.png"
              alt=""
            />
            <img
              v-show="ruleForm.passWord && IsShow"
              @click="IsShow = !IsShow"
              src="../images/闭眼睛.png"
              alt=""
            />
            <img
              v-show="!IsShow"
              @click="IsShow = !IsShow"
              src="../images/眼睛.png"
              alt=""
            />
          </template>
        </el-input>
      </el-form-item>
      <el-form-item style="margin-bottom: 65px">
        <el-checkbox v-model="checked" label="1">
          阅读并同意
          <!-- <span class="note" @click.prevent="showAgreement">《风险告知》</span>
          <span class="note" @click.prevent="showMark">《入市须知》</span> -->

          <span class="note" @click.prevent="showAgreement(592)">&nbsp;《风险告知》</span>
          <span class="note" @click.prevent="showAgreement(591)">《入市须知》</span>
          <span class="note" @click.prevent="showAgreement(598)">《用户协议》</span>
          <span class="note" @click.prevent="showAgreement(597)">《隐私政策》</span>
        </el-checkbox>
      </el-form-item>
      <el-form-item>
        <el-button @click="submitForm('ruleForm')"  :class="{'btn-active':checked&&IsDisabled&&ruleForm.passWord}">登录</el-button>
        <div class="serviceTel" v-if="APP_WINNY_NAME !== '景陶易购'">{{ APP_hotline }}</div>
      </el-form-item>
      <el-form-item class="RegisterTip">
        <span>还没有账号？</span>
        <a href="#" @click="toLogin">立即注册</a>
      </el-form-item>
      <el-dialog title="收货地址" :visible.sync="dialogTableVisible">
        
      </el-dialog>
      <cmsEntryAgreement ref="cmsEntryAgreement" @confirm="confirmAgree" />
    </el-form>
  </div>

</template>

<script>
import cmsEntryAgreement from '../../../components/base/entryAgreement/cmsEntryAgreement.vue';
export default {
  components:{
    cmsEntryAgreement
  },
  data() {
    const loginBtn = (rule,value,callback)=>{
      const reg = /[^/d]{11}/
      if(!value){
        this.IsDisabled = false
        callback(new Error('请输入手机号码'))
      }else if(!reg.test(value)){
        this.IsDisabled = false
        callback(new Error('请输入11位手机号码'))
      }else{
        this.IsDisabled = true
        callback()
      }
    }
    return {
      APP_hotline: window.g.APP_hotline,
      APP_WINNY_NAME: window.g.APP_WINNY_NAME,
      IsDisabled: false,
      cmsEntryAgreement: null,
      dialogTableVisible: false,
      clearShow:false,
      telRef: null,
      IsShow: true,
      checked: false,
      ruleForm: {
        tel: '',
        passWord: '',
        msgValidateCode: '',
        tupian: ''
      },
      loginValue: {
        captchaCode: '', // 图形验证码
        captchaId: '', // 验证码序列号
        loginAccount: '', // 登录账号
        marketId: 28, // 市场id
        terminalType: 4, // 终端类型
        type: '1', // 登录方式 1 ：账号密码登录 2 短信验证码登录
        code: '', // 短信/邮箱验证码 false
        password: '', // 密码 false
        username: this.$route.query.username ? this.$route.query.username : ''
      },
      
      rules: {
        tel: [
          {
            validator: loginBtn,
            trigger: 'blur'
          },
          {
            min: 11,
            max: 11,
            message: "请输入11位手机号码",
            trigger: "blur",
          },
        ],
        passWord: [
          {
            required: true,
            message: "请输入登录密码",
            trigger: "blur",
          },
        ],
      },
    };
  },
  methods: {
    confirmAgree() {
      this.checked = true
    },
    showAgreement(id) {
    this.$refs.cmsEntryAgreement.showDia(id)
    },
    showMark() {
      this.$refs.cmsEntryAgreement.showDia(591)
    },
    dialogHandle(){
      this.dialogTableVisible = true
    },
    clearHandle(){
      this.$refs.telRef.focus()
      this.ruleForm.tel = null;
    },
    toLogin() {
      this.$emit("switchStatus", "register");
    },
    changLoginWay() {
      console.log(1111);
      console.log(protocol);
      this.$refs['ruleForm'].clearValidate()
    },
    submitForm(formName){
       this.$refs[formName].validate((valid) => {
        if (valid) {
          if(!this.checked){
            this.$message.error('请勾选阅读并同意《风险告知》《入市须知》《用户协议》和《隐私政策》')
            return
          }
          let loginProtol = BaseApi.login
          const self = this
          const tel = self.ruleForm.tel
          // 向后台发送用户登录名和密码
          this.loginValue.captchaCode = this.ruleForm.tupian // 图形验证码
          // captchaId
          this.loginValue.loginAccount = this.ruleForm.tel
          this.btnEnable = true
          this.loginValue.password = this.ruleForm.passWord
          this.loginValue.code = this.ruleForm.msgValidateCode
          loginProtol(this.loginValue).then(response => {
            const { code, message, value } = response.data
            if (code == 0) {
              // 清除历史账号访问交易页面商品缓存信息
              this.$store.commit('item', {})
              if (value && value.banTime) {
                this.$message(value.banTime)
                return
              }
              // 当记住密码的checbox选中时，像localStorage里存入一下用户输入的用户名和密码
              // if (self.checked == true) {
              //   self.setlocalStorage(self.ruleForm.tel, self.ruleForm.passWord)
              // } else {
              //   self.setlocalStorage('', '')
              // }
              const sessionInfo = {}
              sessionInfo.isLogin = true
              sessionInfo.userId = value.userId
              sessionInfo.sessionStr = value.sessionStr
              sessionInfo.firmCode = value.userCode
              sessionInfo.tel = tel
              sessionInfo.firmId = value.firmId
              sessionInfo.userType = value.type
              sessionInfo.userName = value.userName
              sessionInfo.lnvitationCode = value.lnvitationCode
              this.$store.commit('setSessionInfo', sessionInfo)
              // 为扫码跳移动端做准备
              const urlQr = `cellPhone=${tel}&lnvitationCode=${value.lnvitationCode}&sessionStr=${value.sessionStr}&type=${value.type}&userCode=${value.userCode}&userId=${value.userId}&userName=${value.userName}`
              localStorage.setItem('qrContent', urlQr)
              localStorage.setItem('myPhone', tel)
              const sessionStr = response.data.value.sessionStr
              const sessionUserId = response.data.value.userId
              const sessionFirmId = response.data.value.firmId
              const sessionFirmCode = response.data.value.userCode
              const sessionTel = tel
              const lnvitationCode = value.lnvitationCode
              const sessionUserType = response.data.value.type
              const userName = response.data.value.userName
              // 将session信息存到localstorage中
              sessionStorage.sessionStr = sessionStr
              sessionStorage.sessionUserId = sessionUserId
              sessionStorage.sessionFirmCode = sessionFirmCode
              sessionStorage.sessionTel = sessionTel
              sessionStorage.userType = sessionUserType
              localStorage.setItem('lnvitationCode_w', lnvitationCode)
              localStorage.setItem('userName', userName)
              // 修改请求参数的登录信息
              for (const item in protocol) {
                if (protocol[item].param) {
                  if ('sessionStr' in protocol[item].param) {
                    protocol[item].param.sessionStr = sessionStr
                    protocol[item].param.userId = sessionUserId
                  }
                }
              }
              for (const key in protocol) {
                if (protocol[key].param) {
                  if ('firmId' in protocol[key].param) {
                    protocol[key].param.firmId = sessionFirmId
                  }
                  if ('ffirmId' in protocol[key].param) {
                    protocol[key].param.ffirmId = sessionFirmId
                  }
                  if ('firmCode' in protocol[key].param) {
                    protocol[key].param.firmCode = sessionFirmCode
                  }
                  if ('tel' in protocol[key].param) {
                    protocol[key].param.tel = sessionTel
                  }
                }
                if (protocol[key].data) {
                  if ('firmIds' in protocol[key].data) {
                    protocol[key].data.firmIds = sessionFirmId
                  }
                  if ('firmId' in protocol[key].data) {
                    protocol[key].data.firmId = sessionFirmId
                  }
                }
              }
              // this.userRiskTimePastDue()
              this.queryCommodityStrategy()
              // this.getMoneyPwdFlgByFirmId()
              // this.sendMsgLoginInformation()
              // this.btnEnable = false
            } else {
              // this.VerificationCode()
              this.$message(message)
              this.btnEnable = false
            }
          }).catch(() => {
            this.btnEnable = false
          })
          setTimeout(()=>{
            this.ruleForm.passWord = null
          }, 3000)
        }
      })
    },
        // 商品策略查询
    queryCommodityStrategy() {
      const _this = this
      http.postFront(protocol.param_queryCommodityStrategy).then((response) => {
        const { code, message, value } = response.data
        if (code == 0) {
          this.$store.commit('setQueryTradeAuthArr', value)
          this.$store.commit('setCommodityStrategy', value)
          hqWs.send(hqProtocol.param_SYMBOLS)
          hqWs.send(hqProtocol.param_businessJb)
          if (value.length > 0) {
            this.$router.push('/quotationList')
          } else {
            this.$message('暂未关联商品')
            // this.$router.push('/quotationListNosession')
          }
        } else {
          this.$message(message)
          // this.$router.push('/quotationList')
          setTimeout(() => {
            _this.queryCommodityStrategy()
          }, 1000)
        }
      }).catch((e) => {
        setTimeout(() => {
          _this.queryCommodityStrategy()
        }, 1000)
      })
    },
        // 登录后发送短信验证码
    // sendMsgLoginInformation() {
    //   protocol.param_sendMsgLoginInformation.param.params = [
    //     util.dateFormateC(new Date()), 'pc端'
    //   ]
    //   http.postFront(protocol.param_sendMsgLoginInformation).then(response => {
    //   })
    // },
  },
};
</script>

<style lang="scss" scoped>
.loginForm {
  .serviceTel{
    margin-top: 20px;
    color: #999999;
  }
  /deep/ .el-form-item__content{
    line-height: 14px;
  }
  /deep/ .el-checkbox__label{
    font-family: Source Han Sans SC !important;
    font-weight: 200 !important;
    font-size: 12px !important;
    color: #999999 !important;
  } 
  /deep/ .el-input__suffix {
    display: flex;
    align-items: center;
    margin-right: 14px;
    img {
      cursor: pointer;
      width: 17px;
      height: 10px;
    }
  }
  .RegisterTip a{
    font-family: Source Han Sans SC;
    font-weight: 400;
    font-size: 14px;
    color: #333333;
    line-height: 39px;
  }
  .note{
    font-weight: 600;
    color: #333333;
  }
}
</style>